import { z } from "zod";

/**
 * One theme a lens designed: the table itself, before anybody is seated at it.
 * `id` is the lens-local index the assignment prompt offers the model — stable
 * for as long as the themes are, which is what lets a later run seat one more
 * person into the same numbering.
 */
const ClusterThemeSchema = z.object({
  id: z.number(),
  name: z.string(),
  tension: z.string(),
});

export type ClusterTheme = z.output<typeof ClusterThemeSchema>;

const LensThemesSchema = z.object({
  lens: z.string(),
  clusters: z.array(ClusterThemeSchema),
});

export type LensThemes = z.output<typeof LensThemesSchema>;

export const ClusterThemeDesignDataSchema = z.array(LensThemesSchema);
